class ForecastVideoReviews extends HTMLElement {

    constructor() {
        super();

        this.$slider = $(this).find('[data-reviews-slide]');
        this.slick = null;
        this.$videoItems = $(this).find('[data-reviews-video-item]');
        this.$thumbnails = $(this).find('[data-reviews-thumbnails]');
        
        this.$reviewsSwap = $('#video-reviews-swap');
        this.currentFilter = null;
        this.$ambassadors = null;
        this.$customers = null;
        this.$buttonSecondary = null;
        this.$buttonPrimary = null;

        if(this.$slider){ this.initSlider(); }
        if(this.$reviewsSwap){ this.initReviewsSwap(); }
        if(this.$videoItems){ this.initVideoItems(); }
    }

    initReviewsSwap(){
        this.$ambassadors = $(this).find('[data-review-type="ambassador"]');
        this.$customers = $(this).find('[data-review-type="customer"]');

        this.$buttonSecondary = this.$reviewsSwap.find('[data-button-secondary]');
        this.$buttonPrimary = this.$reviewsSwap.find('[data-button-primary]');

        if(!this.$ambassadors.length || !this.$customers.length) {
            this.$buttonSecondary.hide();
            this.$buttonPrimary.hide();
            return;
        }

        this.$buttonSecondary.on('click', (event) => {
            event.preventDefault();
            this.swapReviewType('ambassador'); 
        });

        this.$buttonPrimary.on('click', (event) => {
            event.preventDefault();
            this.swapReviewType('customer');
        });

        this.swapReviewType('customer', true);
    }

    swapReviewType(type, initial = false){
        if(!this.slick) return;
        if(this.currentFilter === type) return;

        if(!initial) {
            this.toggleButtonClasses();
        }
        
        // Filter slides by review type
        this.slick.slick('slickUnfilter');
        this.slick.slick('slickFilter', `[data-review-type="${type}"]`);

        // Filter thumbnails by review type
        $(`[data-reviews-thumbnail]`).hide();
        $(`[data-review-thumbnail-type="${type}"]`).fadeIn(300);

        // Go to first slide
        this.slick.slick('slickGoTo', 0);

        this.currentFilter = type;
    }

    toggleButtonClasses() {
        this.$buttonPrimary
            .toggleClass('btn-primary')
            .toggleClass('btn-secondary');
        this.$buttonSecondary
            .toggleClass('btn-primary')
            .toggleClass('btn-secondary');
    }

    initSlider(){
        this.slick = this.$slider.slick({
            arrows: true,
            prevArrow: window.arrows.icon_prev,
            nextArrow: window.arrows.icon_next,
            dots: false,
            infinite: true,
            slidesToScroll: 1,
            slidesToShow: 1,
            autoplay: true,
            autoplaySpeed: 5000,
            pauseOnHover: true,
            pauseOnFocus: true,
            pauseOnScroll: true,
            pauseOnClick: true,
            pauseOnTouch: true,
            pauseOnMouseEnter: true,
            pauseOnMouseLeave: true,
            pauseOnMouseMove: true,
            pauseOnMouseLeave: true,
        });

        this.slick.on('afterChange', (event, slick, currentSlide) => {
            this.setActiveThumbnail(currentSlide);
        });

        this.slick.on('beforeChange', (event, slick, currentSlide) => {
            if(this.$videoItems.length) {
                // pause current video
                const $currentVideo = this.$videoItems.eq(currentSlide).find('[data-reviews-video]');
                if($currentVideo.data('reviews-video') === 'youtube') {
                    this.removeAutoplayParam($currentVideo);
                } else {
                    $currentVideo.find('video').get(0).pause();
                }
            }
        });

        this.initThumbnails();
    }

    initThumbnails(){
        this.$thumbnails.find('[data-reviews-thumbnail]').each((index, thumbnail) => {
            if(index === 0) $(thumbnail).addClass('active');
            $(thumbnail).on('click', (event) => {
                this.slick.slick('slickGoTo', $(event.currentTarget).data('reviews-thumbnail'));
            });
        });
    }

    setActiveThumbnail(index){
        const $thumbnails = $(this).find('[data-reviews-thumbnails]');
        $thumbnails.find('[data-reviews-thumbnail]').removeClass('active').removeClass('pre-active');
        $thumbnails.find(`[data-reviews-thumbnail="${index}"]`).addClass('active');
        $thumbnails.find(`[data-reviews-thumbnail="${index-1}"]`).addClass('pre-active');
        $thumbnails.find(`[data-reviews-thumbnail="${index+1}"]`).addClass('pre-active');
    }

    initVideoItems(){
        this.$videoItems.each((index, videoItem) => {
            $(videoItem).find('[data-reviews-video-button]').on('click', () => {
                this.swapVideo($(videoItem));
            });
        });
    }

    swapVideo($element) {
        this.slick.slick('slickPause');

        const $image = $element.find('[data-reviews-image]');
        const $video = $element.find('[data-reviews-video]');
        const videoType = $video.data('reviews-video');

        const imageHeight = $image.height();
        if (imageHeight) {
            $video.css('height', imageHeight + 'px');
        }
        
        $image.hide();
        $video.fadeIn(300, () => {
            if(videoType === 'youtube') {
                this.removeAutoplayParam($video);
                $video.find('iframe').attr('src', $video.find('iframe').attr('src') + '?autoplay=1');
            } else {
                $video.find('video').get(0).play();
            }
        });
    }
    
    removeAutoplayParam($element){
        const $iframe = $element.find('iframe');
        let src = $iframe.attr('src');
        src = src.replace(/([?&])autoplay=\d+(&)?/, (match, p1, p2) => {
            return p2 ? p1 : '';
        });
        src = src.replace(/[?&]$/, '');
        $iframe.attr('src', src);
    }

}

customElements.define('forecast-video-reviews', ForecastVideoReviews);